import { StepRun as StepRunModel } from "@/models/flows";
import { StepType, RunStatus, ACTIONS } from "@/constants/flows";
import { relativeDateAndTimeFormat } from "@/utils/date";
import { ApprovalStep } from "./steps/ApprovalStep";
import { SendEmail } from "./steps/SendEmail";
import { InputData } from "./InputData";
import { SendFormAndWait } from "./steps/SendFormAndWait";
import { RequestPayment } from "./steps/RequestPayment";
import { DelayStep } from "./steps/DelayStep";

interface Props {
  stepRun: StepRunModel;
  nextStepRun?: StepRunModel; // Optional next step
}

export const StepRun = ({ stepRun, nextStepRun }: Props) => {
  const stepType = stepRun.step.stepType;
  let stepAction = null;

  // Find the relevant action based on stepType
  for (const category in ACTIONS) {
    stepAction = ACTIONS[category].find((action) => action.type === stepType);
    if (stepAction) break;
  }

  const icon = stepAction?.icon || null;
  const colour = stepAction?.colour || "gray";

  // Determine the colour of the next step
  let nextColour = "gray";
  if (nextStepRun) {
    const nextStepType = nextStepRun.step.stepType;
    for (const category in ACTIONS) {
      const nextStepAction = ACTIONS[category].find(
        (action) => action.type === nextStepType
      );
      if (nextStepAction) {
        nextColour = nextStepAction.colour;
        break;
      }
    }
  }

  const getStepRunComponent = () => {
    switch (stepType) {
      case "approval":
        return <ApprovalStep stepRun={stepRun} />;
      case "send_email":
        return <SendEmail stepRun={stepRun} />;
      case "send_form_and_wait":
        return <SendFormAndWait stepRun={stepRun} />;
      case "request_payment":
        return <RequestPayment stepRun={stepRun} />;
      case "delay":
        return <DelayStep stepRun={stepRun} />;
      default:
        return (
          <div className="dark:text-white">Work in progress, coming soon</div>
        );
    }
  };

  return (
    <div className="relative">
      <div
        className={`h-full absolute -mt-4 w-0.5 ml-5 z-10 mt-8 bg-${colour}-500`}
      ></div>
      <div
        className={`border dark:border-white/5 dark:bg-zinc-800 w-full rounded-md p-1.5`}
      >
        <div className="flex">
          <div
            className={`bg-${colour}-500 inline-flex p-1 rounded-md relative z-10`}
          >
            {icon && <stepAction.icon className="h-5 w-5 text-white" />}
          </div>
          <div className="flex items-center justify-between w-full ml-2 text-sm">
            <h2 className="dark:text-white font-medium text-zinc-500">
              {stepRun.step.name}
            </h2>
          </div>
        </div>
      </div>
      <div className="shadow-lg border dark:border-white/5 dark:bg-zinc-800 w-full rounded-md p-1.5 mt-2 relative text-zinc-500">
        <div className="pb-3 pt-4">
          <div className="ml-9">
            <h4 className={`text-${colour}-500`}>ID {stepRun.id}</h4>
            <h5 className="text-xs mt-1 dark:text-zinc-300 text-zinc-500">
              {relativeDateAndTimeFormat(stepRun.startedAt)}
            </h5>
          </div>

          <div className="mt-2 ml-9">{getStepRunComponent()}</div>
        </div>
      </div>
    </div>
  );
};
